var De = Object.defineProperty;
var Ne = (e, t, n) => t in e ? De(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var M = (e, t, n) => (Ne(e, typeof t != "symbol" ? t + "" : t, n), n);
import { prop as de, always as me, path as Me, identity as J, pipe as pe, flatten as ve, map as B, trim as H, filter as X, uniq as je, join as he, either as Re, split as xe, into as qe, compose as ge, toLower as Ce } from "ramda";
import { shallowEqualArrays as Pe, shallowEqualObjects as ze } from "shallow-equal";
import { Duration as ne, DateTime as w } from "luxon";
import L from "humanize-duration";
import _e, { minutes as Be } from "milliseconds";
import { useRef as y, useState as A, useCallback as O, useEffect as T, useMemo as Le } from "react";
import ye from "memoize-one";
import ke from "bows";
import be from "nano-memoize";
import { inflect as Fe } from "inflection";
import k from "color";
import f from "prop-types";
const E = () => typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : typeof globalThis < "u" ? globalThis : null;
/*!
 * Copyright 2015 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */
const F = E();
F.requestIdleCallback = F.requestIdleCallback || function(t) {
  return setTimeout(() => {
    const n = Date.now();
    t({
      didTimeout: !1,
      timeRemaining() {
        return Math.max(0, 50 - (Date.now() - n));
      }
    });
  }, 500);
};
F.cancelIdleCallback = F.cancelIdleCallback || function(t) {
  clearTimeout(t);
};
const V = E();
typeof V.document < "u" && !("ResizeObserver" in V) && import("@juggle/resize-observer").then(({ ResizeObserver: e }) => {
  V.ResizeObserver = e;
});
const He = Object.prototype.toString, $ = (e) => {
  var n;
  const t = (n = e == null ? void 0 : e.constructor) == null ? void 0 : n.name;
  return t || He.call(e).split(/[\[ \]]/)[2] || "Unknown";
}, Te = (e, t = !1) => {
  if (e !== e)
    return String(e);
  const n = $(e);
  if (e == null)
    return n;
  if (Array.isArray(e)) {
    const { 0: o } = e, s = o ? $(o) : "Unknown";
    return `${n}(${e.length})<${s}>`;
  }
  if (n === "Map" || n === "Set") {
    const o = e.entries().next();
    if (o.value) {
      const [s, i] = o.value;
      return `${n}(${e.size})<${$(s)}${n === "Map" ? `, ${$(i)}` : ""}>`;
    }
    return `${n}(${e.size})`;
  }
  const r = n === "Object" ? Object.keys(e) : null;
  return `${n}(${n === "Object" ? `{ ${t ? r.length : r.join(", ")} }` : String(e)})`;
}, re = (e) => Boolean($(e).match(/^Date(Time)?$/)), K = (e, t, n = 1, r = 1) => {
  if (n > 5)
    throw new Error("Keep it shallow, please. Use ramda.equals for deep checks.");
  let o = e === t;
  const s = !e || !t, i = typeof e, u = typeof t;
  return o || s || i !== "object" && u !== "object" || !(i === u) ? o : (o = Array.isArray(e) ? Pe(e, t) : ze(e, t), re(e) && re(t) ? +e == +t : (!o && n > r && (o = Object.keys(e).length === Object.keys(t).length ? Object.keys(e).every((c) => K(e[c], t[c], n, r + 1)) : !1), o));
}, Ue = Object.freeze([]), D = Object.freeze({}), R = Object.freeze(["xs", "sm", "md", "lg", "xl"]), oe = Object.freeze({
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
}), Ve = (1 + Math.sqrt(5)) / 2, we = (e) => e / Ve, Ge = (e, t) => {
  const n = we(e);
  return e - (e - n) * t;
}, kt = (e = 1) => Array.from({ length: Math.ceil(e) }).reduce((t, n, r) => e >= r + 1 ? we(t) : Ge(t, e - r), 1), Ft = (e) => e.hour * 60 * 60 + e.minute * 60 + e.second, Ht = (e) => {
  const t = e.split(/\D/g).slice(0, -1).map((n) => Number(n) || 0);
  if (t.length === 3) {
    const [n, r, o] = t;
    return ne.fromObject({ hours: n, minutes: r, seconds: o }).as("milliseconds");
  }
  if (t.length === 4) {
    const [n, r, o, s] = t;
    return ne.fromObject({ days: n, hours: r, minutes: o, seconds: s }).as("milliseconds");
  }
  return 0;
}, b = (e, t) => {
  if (e === "now")
    return w.local();
  if (w.isDateTime(e))
    return e;
  if (typeof e == "number" || !Number.isNaN(Number(e)))
    return w.fromMillis(Number(e), t);
  const n = typeof e == "string";
  let r = n ? w.fromISO(e, t) : w.fromJSDate(e, t);
  return !r.isValid && e && n && (r = w.fromJSDate(new Date(e), t)), r;
}, Ut = (e) => e instanceof Date ? e : b(e).toJSDate(), _ = {
  FULL_DATE: {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long"
  },
  FULL_TIME: {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  },
  LONG_DATE: {
    month: "long",
    day: "numeric",
    year: "numeric"
  },
  LONG_TIME: {
    hour: "2-digit",
    minute: "2-digit"
  },
  SHORT_DATE: {
    month: "numeric",
    day: "numeric",
    year: "2-digit"
  },
  SHORT_DATETIME: {
    month: "numeric",
    day: "numeric",
    year: "2-digit",
    hour: "numeric",
    minute: "numeric"
  },
  SHORT_TIME: {
    hour: "numeric",
    minute: "numeric"
  },
  TINY_DATE: {
    month: "numeric",
    day: "numeric"
  },
  TINY_DATETIME: {
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric"
  },
  LONG_MONTH: {
    month: "long",
    day: "numeric"
  },
  SHORT_MONTH: {
    month: "short",
    day: "numeric"
  }
}, Ee = (e, t = _.LONG_DATE, n) => b(e, n).toLocaleString(t in _ ? _[t] : t);
Object.assign(Ee, _);
const Vt = (...e) => (console.warn([
  "formattedDate is deprecated and will be removed in version 2.",
  "Please update your code to use formatDateTime instead."
].join(" ")), Ee(...e)), Qe = (e, t = "now") => {
  const n = b(t).diff(b(e)), r = Math.floor(n.as("days")), o = Math.abs(r);
  let s = "";
  return o > 20 ? s = L(Math.abs(n.as("milliseconds")), {
    round: !0,
    units: [o > 60 ? "mo" : "w"]
  }) : o > 1 ? s = L(Math.abs(n.as("milliseconds")), {
    round: !0,
    units: ["d"]
  }) : o === 1 ? s = r > 0 ? "yesterday" : "tomorrow" : s = "today", { daysDiff: r, text: s };
}, Ze = {
  after: ({ text: e }) => `${e} ago`,
  before: ({ text: e }) => `in ${e}`
}, Gt = (e, t, n = Ze) => {
  if (!e)
    return { daysDiff: 0, text: "" };
  const r = Qe(b(e), t), { daysDiff: o } = r;
  return n.default ? { daysDiff: o, text: n.default(r) } : o > 1 ? { daysDiff: o, text: n.after(r) } : o < -1 ? { daysDiff: o, text: n.before(r) } : r;
}, We = L.humanizer({
  language: "shortEn",
  languages: {
    shortEn: {
      y: () => "y",
      mo: () => "mo",
      w: () => "w",
      d: () => "d",
      h: () => "h",
      m: () => "m",
      s: () => "s",
      ms: () => "ms"
    }
  },
  delimiter: " ",
  largest: 2,
  round: !0,
  spacer: "",
  units: ["y", "w", "d", "h", "m", "s"]
}), Qt = (e, t = "now", n) => {
  const r = b(t).diff(b(e));
  return Math.abs(r.as("minutes")) < 1 ? "<1m" : We(r.as("milliseconds"), n);
}, Zt = (e, t = b("now")) => {
  const n = t.diff(e).as("milliseconds"), r = L(Math.abs(n), { largest: 1 });
  return _e.seconds(60) > Math.abs(n) ? "now" : n > 0 ? `${r} ago` : `in ${r}`;
}, Wt = (e, t) => w.isDateTime(e) && w.isDateTime(t) && e.equals(t), Ye = (e, t) => e.replace(/{{\s*(\w+)\s*}}/g, (n, r) => t[r] != null ? String(t[r]) : ""), Yt = (e) => Ye.bind(null, e), Jt = (e) => e ? e.replace(/(<[^>]+>)/g, (t) => /<\/?(sub|sup)>/.test(t) ? t : "") : "", Xt = (e, t) => {
  const n = typeof e == "function" ? e : de(e), r = typeof t == "function" ? t : me(t);
  return (o, s) => {
    const i = n(o), u = n(s), l = r(o), d = r(s);
    return i <= u && i + l >= u || i >= u && i <= u + d;
  };
}, Kt = () => {
  const e = E(), { document: t } = e;
  if (!t)
    return 16;
  const n = e.getComputedStyle(t.querySelector(":root"))["font-size"];
  return Number(n.replace("px", "")) || 16;
}, Oe = (e, t = []) => e.parentNode === null ? t : Oe(e.parentNode, t.concat(e)), Je = /auto|scroll/, Xe = (e) => {
  const t = window.getComputedStyle(e, null);
  return Je.test(t.overflow || t.overflowY || t.overflowX || "");
}, en = (e) => e instanceof HTMLElement ? Oe(e).filter(Xe) : [window], tn = (e) => {
  var t;
  return (t = e == null ? void 0 : e.preventDefault) == null ? void 0 : t.call(e);
}, nn = (e, t, n = 0) => {
  const r = e.length / t, o = r >= 2 ? 2 ** Math.round(Math.log2(r)) : Math.round(r);
  return o < 2 ? e : e.filter((s, i) => r > 2 ? (n + i) % o === 0 : (n + i) % o !== 0);
}, Ke = (e) => !e || typeof e == "string" ? e ? e.trim() : "" : Array.isArray(e) ? e.map(Ke).join(`
`) : String(e), et = {
  thousandSeparator: ",",
  suffix: ""
}, tt = (e, t = 0, n = D) => {
  if (e == null || Number.isNaN(e))
    return "";
  const r = { ...et, ...n };
  if (e === parseInt(e, 10) && e < 1e3)
    return r.suffix ? [e, r.suffix].join("\u202F") : e;
  const o = t && 10 ** t, i = (t ? Math.round(e * o) / o : e).toFixed(t).replace(
    /\.\d+$/,
    (p) => p.match(/\.[0]+$/) ? "" : p.replace(/[0]+$/, "")
  ), [u, l] = i.split(".");
  if (!r.thousandSeparator || u.length < 4)
    return [i, r.suffix].filter(Boolean).join(" ");
  const d = u.startsWith("-"), c = d ? u.slice(1) : u, a = [];
  for (let p = c.length; p > 0; p -= 3)
    a.unshift(c.slice(Math.max(0, p - 3), p));
  let m = [a.join(r.thousandSeparator), l].filter(Boolean).join(".");
  return m = r.suffix ? [m, r.suffix].join("\u202F") : m, d ? `-${m}` : m;
}, rn = (...e) => (console.warn([
  "formattedNumber is deprecated and will be removed in version 2.",
  "Please update your code to use formatNumber instead."
].join(" ")), tt(...e)), S = R.slice().reverse(), nt = S.map((e) => {
  const { [R.length - 1]: t } = R, n = R.indexOf(e), r = R[n + 1];
  return [
    `(min-width: ${oe[e]}px)`,
    e !== t ? `(max-width: ${oe[r] - 0.5}px)` : null
  ].filter(Boolean).join(" and ");
}), Ae = () => {
  var e;
  return (e = S.reduce((t, n, r) => {
    const { [r]: o } = nt, s = ut(o);
    return !t && s ? n : t;
  }, null)) != null ? e : "xs";
}, on = Ae, sn = (...e) => {
  const t = y(null), [n, r] = A(null), o = O((s) => {
    s !== null && (t.current = s, r(s.getBoundingClientRect()));
  }, []);
  return T(() => {
    !t.current || r(t.current.getBoundingClientRect());
  }, e), [n, o];
}, Q = (e) => {
  const t = y(D);
  return T(() => {
    t.current = e;
  }, [e]), t.current;
};
Q.INITIAL_STATE = D;
const un = (e = D, t, n = J) => {
  const r = Array.isArray(t) ? Me(t, e) : e[t], o = Q([e, t, n]), s = A(() => n(r, e)), [, i] = s;
  return T(() => {
    if (o === Q.INITIAL_STATE)
      return;
    const u = n(r, e), [l, d] = o, c = n(l[d], l);
    K(u, c) || i(u);
  }, [r, o, e, t, n, i]), s;
}, rt = ye((e, t) => ({ add: e, flush: t })), cn = (e, t = 2, n = 3e3) => {
  const r = y([]), o = y(null), s = O(() => {
    clearTimeout(o.current), o.current = null, e(r.current), r.current = [];
  }, [r, o, e]), i = O(
    (u) => {
      if (clearTimeout(o.current), r.current.push(u), r.current.length >= t) {
        s();
        return;
      }
      o.current = setTimeout(s, n);
    },
    [t, n, o, s]
  );
  return rt(i, s);
}, ln = (e, t = Ae()) => {
  if (!S.includes(e))
    throw new Error(`Invalid breakpoint provided. Valid breakpoints are: ${S.join(", ")}`);
  return S.indexOf(e) <= S.indexOf(t);
}, v = {}, se = ["local", "session"], ee = (e = "local") => {
  if (!se.includes(e))
    throw new TypeError([
      `Error: "${e}" is not a valid storage type.`,
      `Please use one of ${JSON.stringify(se)}.`
    ].join(" "), "~/Lib/safeStorage.js", 5);
  const t = E();
  if (!(`${e}Storage` in t)) {
    if (!(e in v)) {
      const n = Symbol("CONTAINER");
      let r;
      v[e] = new Proxy({
        clear() {
          r = v[e][n] = {};
        },
        getItem(o) {
          return o in r ? r[o] : null;
        },
        key(o) {
          var s;
          return (s = Object.keys(this[n])[o]) != null ? s : null;
        },
        get length() {
          return Object.keys(r).length;
        },
        removeItem(o) {
          delete this[o];
        },
        setItem(o, s) {
          return this[o] = s, String(s);
        }
      }, {
        deleteProperty(o, s) {
          return s in o[n] ? delete o[n][s] : !1;
        },
        get(o, s) {
          if (s !== n)
            return s in o ? o[s] : o[n][s];
        },
        has(o, s) {
          return s in o && s !== n ? !0 : s in o[n];
        },
        set(o, s, i) {
          return s === n && (o[n] = i), o[n][s] = String(i), i;
        }
      }), r = v[e][n] = {};
    }
    return v[e];
  }
  return t[`${e}Storage`];
};
E().safeStorage = ee;
const P = E(), ot = ee("local"), st = () => new Date().toISOString().replace(/^.*:([\d.]+)Z$/, "$1");
var ae, fe;
(((ae = P.config) == null ? void 0 : ae.ENVIRONMENT) !== "production" && ((fe = P.config) == null ? void 0 : fe.ENVIRONMENT) !== "test" || ot.debug === "true" && !console.__ts__) && (console.__ts__ = !0, ["log", "debug", "info", "warn", "error"].forEach((e) => {
  const t = console[e];
  console[e] = (...n) => t.call(console, ...n, "|", st());
}), console.save = (e, t) => {
  if (!e) {
    console.error("Console.save: No data");
    return;
  }
  t || (t = "console.json"), typeof e == "object" && (e = JSON.stringify(e, void 0, 4));
  const n = new Blob([e], { type: "text/json" }), r = document.createEvent("MouseEvents"), o = document.createElement("a");
  o.download = t, o.href = P.URL.createObjectURL(n), o.dataset.downloadurl = ["text/json", o.download, o.href].join(":"), r.initMouseEvent("click", !0, !1, P, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), o.dispatchEvent(r);
});
const it = (e, t = "") => {
  const n = e.displayName || t || e;
  if (!n)
    throw new TypeError(
      `No Component.displayName (${e.displayName}) and no custom identifier (${t || e}) was provided.`
    );
  const r = String(n);
  let o = r, s = [];
  r.match(/^[A-Z]\w+[A-Z/]/) && ([o, ...s] = r.replace("Component", "").replace(/([a-z])([A-Z])/, "$1 $2").replace("/", " ").split(" "));
  const i = s.length ? `${`[${s.join("").slice(0, 15)}]`.padEnd(15)} |` : "", u = ke(o, i);
  return typeof e == "function" && (e.prototype.logger = u), u;
}, j = it("useIsLoaded"), an = (e, t = 1e3) => {
  const n = y(e), [r, o] = A(e ? !1 : null);
  return T(() => {
    j.debug("loading initially", String(e));
    const s = setTimeout(() => {
      o((i) => i === null && !n.current ? (j.debug("setting loaded to true due to timeout"), !0) : i);
    }, t);
    return () => {
      j.debug("clearing timeout"), clearTimeout(s);
    };
  }, []), T(() => {
    n.current = e, r === null && e && (j.debug("loading has started; setting loaded to false"), o(!1)), r === !1 && !e && (j.debug("loading has ended; setting loaded to true"), o(!0));
  }, [r, e]), Boolean(r);
}, ut = (e) => {
  var o;
  const t = y((o = E()) == null ? void 0 : o.matchMedia(e)), [n, r] = A(() => t.current.matches);
  return T(() => {
    var i;
    t.current.media !== e && (t.current = (i = E()) == null ? void 0 : i.matchMedia(e)), t.current.matches !== n && r(t.current.matches);
    const s = () => r(t.current.matches);
    return t.current.addListener("change", s), () => t.current.removeListener("change", s);
  }, [e, n]), n;
}, fn = (e) => {
  const [t, n] = A(0), [r, o] = A(0), s = O(() => {
    n(e.current.offsetWidth), o(e.current.offsetHeight);
  }, [o, n, e]);
  return T(() => (s(), window.addEventListener("resize", s), () => {
    window.removeEventListener("resize", s);
  }), [e, s]), { width: t, height: r };
}, dn = (e, t = 66, n = !1, r) => {
  let o, s, i = 0;
  const u = (...l) => {
    !i && !n && (i = Date.now());
    const d = () => {
      o = null, n || (i = Date.now(), s = e(...l));
    }, c = n && !o || r && i < Date.now() - r;
    return clearTimeout(o), o = setTimeout(d, t), c && (i = Date.now(), s = e(...l)), s;
  };
  return u.cancel = () => {
    clearTimeout(o), o = null;
  }, u;
}, Z = {
  highest: typeof queueMicrotask == "function" ? queueMicrotask : (e) => Promise.resolve().then(e).catch((t) => requestIdleCallback(() => console.error(t))),
  high: (e) => requestAnimationFrame(() => requestAnimationFrame(e)),
  medium: (e) => requestAnimationFrame(() => setTimeout(e, 0)),
  low: typeof requestIdleCallback < "u" ? (e) => requestIdleCallback(e, { timeout: 500 }) : (e) => setTimeout(e, 250),
  lowest: typeof requestIdleCallback < "u" ? requestIdleCallback : (e) => setTimeout(e, 2500)
}, x = (e, t = Z.medium, ...n) => {
  const r = n.length ? e.bind(null, ...n) : e;
  return typeof t == "number" ? setTimeout(r, t) : typeof t == "function" ? t(r) : Z.medium(r);
};
x.priorities = Z;
const mn = (e, t, n = 33, r = 1e4) => {
  let o = !1;
  const s = Date.now(), i = () => {
    if (!o && (t() || Date.now() - s >= r)) {
      e();
      return;
    }
    o || x(i, n);
  };
  return i(), function() {
    o = !0;
  };
}, pn = (e, t) => x.bind(null, e, t), ct = (e) => {
  let t;
  const n = () => {
    cancelAnimationFrame(t), t = null;
  }, r = (...o) => {
    const s = () => {
      t = null, e(...o);
    };
    return n(), t = requestAnimationFrame(s), t;
  };
  return r.cancel = () => {
    n();
  }, r;
}, hn = (e, t = 250) => {
  let n, r, o;
  return (...s) => (r ? (clearTimeout(n), n = setTimeout(() => {
    Date.now() - r >= t && (o = e(...s), r = Date.now());
  }, t - (Date.now() - r))) : (o = e(...s), r = Date.now()), o);
}, gn = () => {
  const e = y(null), [t, n] = A({ width: null, height: null });
  return T(() => {
    const { current: r } = e;
    let o, s, i = 0, u;
    const l = () => {
      var m, p;
      const { width: c, height: a } = (p = (m = e.current) == null ? void 0 : m.getBoundingClientRect()) != null ? p : D;
      u && clearTimeout(u), n((h) => c !== h.width || a !== h.height ? { width: c, height: a } : h), u = setTimeout(l, 166);
    }, d = () => {
      o = new ResizeObserver(ct(l)), o.observe(r);
    };
    if (typeof ResizeObserver > "u" && typeof setInterval < "u") {
      let c = !1;
      s = setInterval(() => {
        i += 1, typeof ResizeObserver < "u" && (d(), c = !0), i >= 100 && (c = !0), c && (clearInterval(s), s = null);
      }, 66);
    } else
      d();
    return () => {
      o && o.unobserve(r), s && clearInterval(s);
    };
  }, [e]), Le(() => ({
    ref: (r) => {
      e.current = r;
    },
    ...t
  }), [t]);
}, W = {
  depth: 2,
  maxAge: Be(60)
}, te = (e, t) => be(e, { ...W, ...t }), yn = (e, t = W) => {
  const { depth: n, ...r } = t;
  return be(e, {
    ...W,
    ...r,
    equals: (o, s) => K(o, s, n)
  });
}, lt = te((e, t) => (n) => {
  const { flush: r, maxQueued: o, queue: s, scheduled: i, timeout: u } = t;
  return clearTimeout(i.current), s.current = { ...s.current, [e]: n }, Object.keys(s.current).length === o ? r() : (i.current = setTimeout(r, u), i.current);
}), at = ye((e, t, n, r) => ({
  pause: e,
  restart: t,
  flush: n,
  add: r
})), bn = (e) => {
  const { maxQueued: t = 2, timeout: n = 3e3 } = e, r = y(e.handlers);
  T(() => {
    Object.entries(e.handlers).forEach(([a, m]) => {
      r.current[a] !== m && (r.current[a] = m);
    });
  }, [e.handlers]);
  const o = y({}), s = y(null), i = O(() => {
    clearTimeout(s.current), s.current = null;
  }, [s]), u = O(() => {
    const a = o.current;
    o.current = {}, i(), Object.entries(a).forEach(([m, p]) => {
      var h, U;
      return (U = (h = r.current) == null ? void 0 : h[m]) == null ? void 0 : U.call(h, p);
    }), typeof e.onFlush == "function" && x(e.onFlush, x.priorities.low);
  }, [r, o, i, e.onFlush]), l = O(() => {
    const a = Object.keys(o.current).length;
    return a ? a === t ? u() : (s.current = setTimeout(u, n), s.current) : null;
  }, [o, u, t, n]), d = y({
    queue: o,
    flush: u,
    scheduled: s,
    maxQueued: t,
    timeout: n
  }), c = y(
    Object.entries(e.handlers).reduce(
      (a, [m]) => ({
        ...a,
        [m]: lt(m, d.current)
      }),
      D
    )
  );
  return at(i, l, u, c.current);
}, ft = (e = 10) => [...typeof crypto < "u" ? crypto.getRandomValues(new Uint8Array(e)) : Array.from({ length: e }, () => Math.ceil(Math.random() * 255))].map((t) => t.toString(36)).join(""), Tn = () => {
  const e = ee("session");
  let t = e.getItem("aroyaClientId");
  return t || (t = ft(), e.setItem("aroyaClientId", t)), t;
}, wn = de("id");
let ie = 0;
const En = (e) => (ie += 1, String(e) + ie), On = (e) => {
  if (Boolean(e) === e)
    return !0;
  if (e == null)
    return !1;
  if (Array.isArray(e))
    return Boolean(e.length);
  if (e instanceof Date)
    return Boolean(e.getTime());
  const t = typeof e == "object";
  return t && "isValid" in e ? e.isValid : Boolean(t ? Object.keys(e) : e);
}, g = 453.59237, Ie = {
  g: {
    mg: 1e3,
    oz: 16 / g,
    lb: 1 / g,
    kg: 1 / 1e3
  },
  kg: {
    mg: 1e6,
    g: 1e3,
    oz: 16 * (1e3 / g),
    lb: 1e3 / g
  },
  mg: {
    g: 1 / 1e3,
    oz: 16 / (g * 1e3),
    lb: 1 / (g * 1e3),
    kg: 1 / 1e6
  },
  lb: {
    mg: g * 1e3,
    g,
    oz: 16,
    kg: g / 1e3
  },
  oz: {
    mg: g / 16 * 1e3,
    g: g / 16,
    lb: 0.0625,
    kg: g / 16 / 1e3
  }
}, An = Object.keys(Ie), In = (e, t, n = t) => {
  var o;
  if (t === n)
    return e;
  const r = (o = Ie[t]) == null ? void 0 : o[n];
  return r ? e * r : (console.error(`invalid source (${t}) or target (${n}) unit`), NaN);
}, ue = (e) => typeof e != "number", Y = (e) => {
  var r, o;
  if (typeof e == "string" || !e)
    return [e != null ? e : ""];
  let t = e;
  if ((r = e == null ? void 0 : e.error) != null && r.response && (t = e.error.response, typeof t == "string"))
    return [t];
  let n = Ue;
  return Array.isArray(t) && (n = t.every((s) => typeof s == "string") ? t : t.filter(ue).map(Y)), (o = Object.keys(t)) != null && o.length && (n = Object.values(t).filter(ue).map(Y)), n;
}, $n = pe(Y, ve, B(H), X(Boolean), je, he(`
`)), Sn = (e, t) => {
  if (!e)
    return 0;
  if (!t || typeof t != "number")
    return Math.round(e);
  const n = 10 ** t;
  return Math.round(e * n) / n;
}, dt = (e, t) => e == null || t == null || !e.localeCompare || !t.localeCompare ? (console.error("[textSort] not a string:", { a: e, b: t }), 0) : e.localeCompare(t, void 0, { numeric: !0, ignorePunctuation: !0 }), Dn = (e, t = J, n) => {
  if (!e || !e.length)
    return "";
  const r = e.map(Re(t, me(""))).sort(dt), { 0: o } = r;
  if (r.length === 1)
    return o;
  const s = o.split(/\W/g).filter((a) => r.every((m) => m.includes(a))).join(" ").trim();
  if (!(s != null && s.length))
    return n;
  const i = r.map((a) => a.replace(s, "").trim());
  if (!i.map((a) => Array.from(a).reduce((m, p) => m + p.charCodeAt(0), 0)).every((a, m, p) => {
    const h = m + 1;
    return h in p ? p[h] === a + 1 : !0;
  }))
    return n;
  const { 0: d, [r.length - 1]: c } = i;
  return `${Fe(s, r.length)} ${d}-${c}`;
}, Nn = (e) => e != null && typeof e != "object" ? String(e).replace(/[.*+?^${}()|[\]\\]/g, "\\$&") : "", Mn = (e, t = "and") => {
  var r;
  if (!Array.isArray(e))
    return e;
  if (e.length < 2)
    return (r = e[0]) != null ? r : "";
  const { [e.length - 1]: n } = e;
  return `${e.slice(0, -1).join(", ")} ${t} ${n}`;
}, mt = { increment: 6, separator: "\xA0", toArray: !1 }, pt = /^\s+|\s+$/, vn = (e, t) => {
  if (typeof e != "string")
    return "";
  const n = { ...mt, ...t }, { increment: r, separator: o, toArray: s } = n, i = new RegExp(`(.{${r}})`, "g"), u = e.split(i).filter((l) => Boolean(l.replace(pt, "")));
  return s ? u : u.join(o);
}, ht = /[a-zA-Z0-9 ]/, jn = (e) => typeof e == "string" ? e.replace(/[^a-zA-Z0-9 ]/g, "").split(/([a-zA-Z]+\s+)/).filter((t) => t && t.match(ht)).map((t) => t.match(/^\d+$/) ? ` ${t}` : t.charAt(0).toUpperCase()).join("") : "", Rn = (e) => typeof e == "string" ? e.slice(e.search(/\w/)).split(/\W+/).filter(Boolean).map((t) => (t.match(/^[\dA-Z]+$/) ? t.slice(0, 8) : t[0]).toUpperCase()).join("") : "", xn = pe(
  String,
  xe(/[^a-zA-Z0-9]+/g),
  qe([], ge(B(H), X(Boolean), B(Ce))),
  he("-")
), G = 2.5, qn = te((e, t) => {
  let n = k(e);
  const r = n.contrast(k(t));
  return r < G - G / 10 && (n = n.lighten((G - r) / r)), n;
}), z = 2.1, Cn = te((e, t) => {
  let n = k(e);
  const r = k(t), o = r.mix(n, 0.68), s = o.contrast(r), i = Math.abs(r.hue() - o.hue());
  if (s < z - z / 10 || i < 36) {
    const u = i >= 50 ? (z - s) / s : (z - s) / s + (50 - i) / i / 2;
    n = n.lighten(u);
  }
  return n;
}), Pn = () => null, zn = (e) => Number(e) || void 0, gt = (e) => Number(e) || null, _n = (e) => Number(e) === e ? e : null, Bn = ge(
  X(J),
  B(gt)
), Ln = (e) => {
  if (typeof e == "string") {
    const t = H(e);
    if (t.length)
      return t;
  }
  return null;
}, kn = (e) => {
  if (Array.isArray(e) && e.length > 0) {
    const t = e.filter((n) => Number(n) === n ? !0 : n);
    if (t.length)
      return t;
  }
  return null;
}, Fn = (e) => {
  if (e == null)
    return null;
  const t = b(e);
  return t.isValid ? t.toISODate() : null;
}, Hn = (e) => {
  const t = b(e);
  return t.isValid ? t.toUTC().toISO() : null;
}, Un = (e) => {
  const t = H(e);
  return t.length ? t.replace(/^\s*\+?1?\s*/, "").replace(/[^\d]/g, "").slice(0, 10) : null;
}, q = (e, t, n) => `Invalid prop '${t}' of type '${Te(e)}' supplied to '${n}'.`, I = (e) => e.replace(/(\s)\s+/g, "$1"), yt = Symbol.for("react.memo"), bt = Symbol.for("react.element"), ce = (e) => {
  const t = $(e);
  if (["String", "Function", "Null"].some((r) => r === t) || e && typeof e.render == "function")
    return !0;
  const n = e && e.$$typeof;
  return n === yt || n === bt;
}, Vn = f.oneOfType([
  f.string,
  f.arrayOf(f.string)
]), Tt = (e) => (...t) => {
  const [n, r, o] = t, s = n[r];
  return !(r in n) || s == null || s === "" ? new Error(
    `'${r}' is required by '${o}', but it wasn't provided.`
  ) : e(...t);
}, N = (e, t = {}) => (e.isRequired = Tt(e), t.nullable && (e.nullable = (n, r, ...o) => {
  if (n[r] != null)
    return e(n, r, ...o);
}), e), wt = (e) => e == null || typeof e == "object" && !Object.keys(e).length, Gn = (e = {}) => {
  const t = Object.entries(e);
  if (!t.length || t.length === 1)
    throw new Error(
      "atLeastOneRequired requires at least two defined propTypes. For one, please use propType.isRequired."
    );
  return t.reduce((n, r, o) => {
    const [s, i] = r, u = t.slice().filter((l, d) => d !== o);
    return {
      ...n,
      [s]: (l, d, c, ...a) => {
        const m = l[d], p = wt(m), h = i(l, d, c, ...a);
        if (p || h) {
          if (!u.find(([C, Se]) => l[C] != null && !Se(l, C, c, ...a)))
            return new Error(
              I(`
              Invalid prop '${d}' passed to '${c}'.
              ${p ? "It did not exist, " : ""}${h ? `It failed validation: [${h.toString()}], ` : " "}and it's alternates: [${u.map(([C]) => C).join(", ")}]
              were not present or failed validation.
            `)
            );
          if (h)
            return h;
        }
      }
    };
  }, {});
}, le = (e, t, n, r) => {
  const o = e.filter((s) => {
    const i = t[s];
    return !(typeof i > "u" || i === null);
  });
  if (t[n] && o.length)
    return new Error(
      `[${r}] cannot have both [${n}] and [${o.join(
        ", "
      )}] props.`
    );
}, Qn = (e, ...t) => {
  const n = (r, o, s, ...i) => le(t, r, o, s) || e(r, o, s, ...i);
  return n.isRequired = (r, o, s, ...i) => le(t, r, o, s) || e.isRequired(r, o, s, ...i), n;
}, Zn = N((e, t, n) => {
  const r = e[t];
  if (!r)
    return;
  if (!b(r).isValid)
    return new Error(
      I(`${q(r, t, n)}. Expected a valid date string or object.`)
    );
}), Et = /^([a-z]+)(_|-)(new-)?(\d+)/i, Ot = [
  (e) => e.match(Et),
  (e) => e === "",
  (e) => e.toLowerCase() === "new"
], At = (e) => typeof e == "string" && Ot.some((t) => t(e)), $e = N(
  (e, t, n) => {
    const r = e[t];
    if (r === void 0)
      return r;
    const o = String(r) !== r && Number(r) !== +r;
    if (!At(r) && (o || !Number(r)))
      return new Error(
        I(`
      ${q(r, t, n)}
      Expected a whole Number greater than 0 or a String convertible to such a Number.
    `)
      );
  },
  { nullable: !0 }
), Wn = f.shape({
  id: $e,
  name: f.string
}), Yn = N((e, t, n) => {
  const r = e[t];
  if (!(Number(r) === +r || r === "" || r == null))
    return new Error(
      I(
        `${q(
          r,
          t,
          n
        )} Expected number or empty string.`
      )
    );
}), Jn = f.shape({
  count: f.number,
  current: f.number,
  next: f.number,
  numPages: f.number,
  pageSize: f.number,
  previous: f.number,
  results: f.arrayOf($e)
}), Xn = f.oneOfType([
  f.func,
  f.shape({ current: f.node })
]), Kn = N((e, t, n) => {
  const r = e[t];
  if (!(Array.isArray(r) && r.every((o) => ce(o))) && !ce(r))
    return new Error(
      I(`
    Invalid prop '${t}' supplied to '${n}'.
    Expected a renderable type: a single (String, Function, { render() {} }, null)
    or an Array of the same.
    Received: ${Te(r)}
  `)
    );
}), er = (e, t = !0) => N(
  (n, r, o) => {
    const s = n[r];
    if (typeof s != "string" || !e.test(s))
      return new Error(
        I(`
        ${q(s, r, o)}
        Expected it to be a string matching pattern (${e})
      `)
      );
  },
  { nullable: t }
), tr = f.objectOf(f.oneOfType([
  f.number,
  f.string
])), nr = (e) => N((t, n, r) => {
  const o = t[n];
  if (!Array.isArray(o))
    return new Error(
      I(`
        ${q(o, n, r)}
        Expected it to be an Array.
      `)
    );
  const s = Math.round(Math.random()) ? o.slice(0, 2) : o.slice(-2);
  for (let i = 0; i < s.length; i += 1) {
    const u = `${n}[${i}]`;
    f.checkPropTypes({ [u]: e }, { [u]: s[i] }, "prop", r);
  }
  return null;
}), rr = (e, t) => (n, r, o) => {
  const { [r]: s, [s]: i } = n;
  return f.checkPropTypes({
    [r]: e,
    [s]: t
  }, {
    [r]: s,
    [s]: i
  }, "prop", o), null;
}, or = f.objectOf(f.string), It = (e, t) => e ? e.nodeName === "HTML" ? -t : e.getBoundingClientRect().top + t : t, $t = (e) => e < 0.5 ? 4 * e * e * e : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1, St = (e, t, n, r) => n > r ? t : e + (t - e) * $t(n / r), sr = ({
  target: e,
  duration: t = 500,
  callback: n,
  context: r = window,
  offset: o = 0
}) => {
  if (e == null)
    return;
  const s = r.scrollTop || window.pageYOffset, i = (typeof e == "number" ? Math.floor(e) : It(e, s)) + o;
  if (i === s) {
    n == null || n();
    return;
  }
  const u = Date.now(), l = () => {
    const d = Date.now() - u, c = St(s, i, d, t);
    r !== window ? r.scrollTop = c : r.scroll(0, c), d >= t ? n == null || n(e) : requestAnimationFrame(l);
  };
  l();
};
class ir {
  constructor() {
    M(this, "queue", /* @__PURE__ */ new Map());
    M(this, "head", 0);
    M(this, "tail", 0);
    M(this, "length", 0);
  }
  push(t) {
    this.queue.set(this.tail, t), this.tail += 1;
  }
  shift() {
    if (this.length > 0) {
      this.length -= 1;
      const t = this.queue.get(this.head);
      return this.queue.delete(this.head), this.head += 1, t;
    }
    return this.head = 0, this.tail = 0, null;
  }
}
export {
  R as BREAKPOINTS,
  oe as BREAKPOINT_VALUES,
  _ as DATE_FORMATS,
  Ue as EMPTY_ARRAY,
  D as EMPTY_OBJECT,
  Ve as GOLDEN_RATIO,
  g as LB_TO_G,
  ir as Queue,
  Ie as WEIGHT_CONVERSIONS,
  An as WEIGHT_UNIT_SYMBOLS,
  Gn as atLeastOneRequired,
  S as breakpointKeys,
  nt as breakpointQueries,
  or as classesType,
  Dn as combineSequentialNames,
  Yt as compileTemplate,
  Ft as convertDateTimeToSeconds,
  In as convertWeight,
  it as createLogger,
  Zn as datePropType,
  dn as debounce,
  q as defaultInvalidMsg,
  W as defaultMemoizerOpts,
  x as defer,
  mn as deferUntil,
  pn as deferred,
  nn as downsampleToMax,
  Jt as dtLabelSanitizer,
  Ht as durationToMillis,
  rr as dynamicPropType,
  Vn as errorMessagePropType,
  Nn as escapeRegExp,
  Qn as exclusiveOf,
  Ae as findBreakpoint,
  Ee as formatDateTime,
  Ke as formatError,
  I as formatErrorMessage,
  Mn as formatList,
  tt as formatNumber,
  vn as formatUID,
  Vt as formattedDate,
  rn as formattedNumber,
  Tn as getClientId,
  Xt as getCollidesWith,
  Ut as getDate,
  Qe as getDateDiff,
  b as getDateTime,
  Gt as getDueDateDiff,
  E as getGlobal,
  wn as getId,
  qn as getMainColor,
  Cn as getMutedColor,
  Kt as getRemSize,
  en as getScrollContexts,
  Qt as getShortDateDiff,
  Zt as getTimeDiff,
  $ as getType,
  kt as goldenth,
  Wn as idAndNameShape,
  $e as idPropType,
  jn as initials,
  ce as innerRenderableType,
  Wt as isEqualDateTime,
  On as isValidParam,
  te as memoize,
  kn as nonEmptyArrayOrNil,
  Ln as nonEmptyStringOrNil,
  Pn as noop,
  Yn as numberOrEmptyType,
  Jn as paginationPropTypes,
  $n as parseApiErrors,
  Un as phoneNumberOrNil,
  tn as preventDefault,
  N as propTypeFactory,
  ct as rafThrottle,
  ft as randomId,
  Xn as refType,
  er as regexPropType,
  Kn as renderableType,
  Te as repr,
  Sn as roundToPrecision,
  ee as safeStorage,
  nr as samplingArrayOf,
  sr as scrollTo,
  K as shallowEquals,
  yn as shallowEqualsMemoizer,
  We as shortDurationHumanizer,
  Rn as shortName,
  xn as slugify,
  tr as stylePropType,
  Ye as templateRenderer,
  dt as textSort,
  hn as throttle,
  Fn as toISODateOrNil,
  Hn as toISOOrNil,
  En as uniqueId,
  on as useBreakpoint,
  sn as useClientRect,
  un as useControlledState,
  cn as useDebouncedBatchQueue,
  ln as useIsBreakpointDown,
  an as useIsLoaded,
  ut as useMediaQuery,
  Q as usePrevious,
  fn as useResize,
  gn as useResizeObserver,
  bn as useTaskQueue,
  Bn as validIdArray,
  gt as validIdOrNil,
  zn as validIdOrUndefined,
  _n as validNumberOrNil
};
